import { IonContent, IonInput, IonPage, IonText } from "@ionic/react"
import moment from "moment"
import { useEffect, useState } from "react"
import { useHistory } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import service from "../../../Service/service"
import Head from "../../Header"
import Sidebar from "../../Sidebar"
import swal from 'sweetalert';

const HRDepartment: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);

    const [data, setData]: any = useState([]);
    const [data1, setData1]: any = useState([]);
    // data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");

    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);


    const [id, setId] = useState('');
    const [id1, setid1] = useState(localStorage.getItem('SignupEmpId'));
    /*............ Create ............ */
    const [DepartmentHead, setDepartmentHead] = useState("");
    const [contactName, setContactName] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [DepartmentName, setDepartmentName] = useState("")
    const [GST, setGST] = useState("");
    const [companyAddress, setCompanyAddress] = useState("");
    const [crtBy] = useState(localStorage.getItem('SignupEmpId'));
    const [updBy] = useState(localStorage.getItem('SignupEmpId'));
    var expr = /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/;
    var regName = /[a-zA-Z]{3,}/;
    var ContactregName = /[a-zA-Z]{3,}/;
    const mailPat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    /*...........View & Update............ */

    const [cname, setCname] = useState("");
    const [contactname, setContactname] = useState("");
    const [DepartmentCode, setDepartmentCode] = useState("");
    const [DepartmentAlternate, setDepartmentAlternate] = useState("");
    const [contactemail, setContactemail] = useState("");
    const [gst, setGst] = useState("");
    const [address, setAddress] = useState("");
    const [Resources, setResources] = useState([]);
    const [Projects, setProjects] = useState([]);
    const [dept, setdept] = useState([])
    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => i + 1,
            sortable: false,
            width: "67px"
        },
        {
            name: "Department Name",
            selector: (itm: any) => itm.departmentName,
            sortable: true,
        },
        {
            name: "Department Head",
            sortable: true,
            selector: (itm: any) => itm.departmentHead
        },
        {
            name: "Department Code",
            selector: (itm: any) => itm.departmentCode,
            sortable: true,
        },
        {
            name: "Department Alternate",
            selector: (itm: any) => itm.departmentAlternate,
            sortable: true,
        },
        {
            name: "Action",
            sortable: false,
            width: "100px",
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral" }}>
                        <IonText style={{ color: "coral", cursor: 'pointer' }} onClick={() => openmodal(itm.id)} >View</IonText>
                    </div>
                </>
            )
        }
    ];

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };

    // const openmodal1 = () => {
    //     setModalopen1(true);
    // }
    const back = () => {
        history.goBack();
    }
    const tabledata = dept.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "500",
                fontSize: "15px",
            },
        },
        cells: {
            style: {
                fontSize: "15px"
            }
        }
    };

    useEffect(() => {
        LoadDepartment(id1);

    }, []);
    const openmodal = (id: any) => {
        setId(id)
        setModalopen1(true);
        service.ViewMyDepartment(id)
            .then((response) => {
                if (response.data.Status == "200") {
                    console.log(response.data.Data);
                    if (response.data.Data.masterDepartment.departmentHead === null || response.data.Data.masterDepartment.departmentHead === "") {
                        setDepartmentHead("")
                    }
                    else {
                        setDepartmentHead(response.data.Data.masterDepartment.departmentHead)
                    }
                    if (response.data.Data.masterDepartment.departmentCode === null || response.data.Data.masterDepartment.departmentCode === "") {
                        setDepartmentCode("")
                    } else {
                        setDepartmentCode(response.data.Data.masterDepartment.departmentCode)
                    }
                    if (response.data.Data.masterDepartment.departmentAlternate === null || response.data.Data.masterDepartment.departmentAlternate === "") {
                        setDepartmentAlternate("")
                    } else {
                        setDepartmentAlternate(response.data.Data.masterDepartment.departmentAlternate)
                    }
                    if (response.data.Data.masterDepartment.departmentName === null || response.data.Data.masterDepartment.departmentName === "") {
                        setDepartmentName("")
                    } else {
                        setDepartmentName(response.data.Data.masterDepartment.departmentAlternate)
                    }
                    if (response.data.Data.projects === null || response.data.Data.projects === "") {
                        setProjects([])
                    } else {
                        setProjects(response.data.Data.projects)
                    }
                    if (response.data.Data.resources === null || response.data.Data.resources === "") {
                        setResources([])
                    } else {
                        setResources(response.data.Data.resources)
                    }
                }
            })
    }
    // const View = () => {
    //     service.ViewMyDepartment()
    //         .then((response) => {
    //             console.log(response.data);
    //             if (response.data.Status === "200") {
    //                 setData([]);
    //             }
    //             else {
    //                 setData(response.data.Data)
    //             }
    //         })
    //         .catch((error) => {
    //             swal(error);

    //         });
    // }
    const LoadDepartment = (id1: any) => {
        setid1(id1)
        service.GetallMyDepartment(id1)
            .then((response) => {
                console.log(response);
                if (response.data.Status === "200") {
                    setdept(response.data.Data)
                    setData1([]);
                }
                else {
                    setdept([])
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const closemodal = () => {
        setModalopen(false);
    }

    const closemodal1 = () => {
        setModalopen1(false);
        setDepartmentHead("");
        setContactName("");
        setContactNo("");
        setGST("");
        setCompanyAddress("");
    }


    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        My Department </h3>
                                </div>
                            </div>
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={tabledata}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    id="logouts-modal"
                    show={modalopen1}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">My Department</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Department Name <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={DepartmentName} onIonChange={(e: any) => setDepartmentName(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Department Head <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={DepartmentHead} onIonChange={(e: any) => setDepartmentHead(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Department Code<span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={DepartmentCode} onIonChange={(e: any) => setDepartmentCode(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label style={{ fontWeight: "bold" }}>Department Alternate <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={DepartmentAlternate} onIonChange={(e: any) => setDepartmentAlternate(e.detail.value)} className="form-control datetimepicker" />
                                </div>
                            </div>
                            <div className="form-group" style={{ marginTop: "2%" }}>
                                <label style={{ fontWeight: "bold" }}>Assigned Projects </label>
                                <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                    {Projects.length > 0 && Projects.map((itm: any) => (
                                        <li>{itm}</li>
                                    ))}
                                </div>
                            </div>
                            <div className="form-group" style={{ marginTop: "2%" }}>
                                <label style={{ fontWeight: "bold" }}>Assigned Resources </label>
                                <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                    {Resources.length > 0 && Resources.map((itm: any) => (
                                        <li>{itm}</li>
                                    ))}
                                </div>
                            </div>
                        </form>
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default HRDepartment;